<div class="lum-c-order-ag-table-line-items  lum-page__ag-grid">
  <div lumAppLoader class="overlay" [loading]="loading" [classes]="'loading'"></div>

  <ag-grid-angular
    class="
      ag-theme-alpine ag-theme-lum ag-theme-lum--next
      lum-page__ag-grid__table
    "
    [gridOptions]="gridOptions"
    [domLayout]="'normal'"
    [rowData]="rowData?.data || []"
    (gridReady)="onGridReady($event)"
    (filterChanged)="onFilterChanged($event)"
  ></ag-grid-angular>

  <div class="lum-paging lum-page__ag-grid__paging">
    <div class="lum-paging__jump-to-page">
      <label class="lum-label my-2">Page</label>
      <input
        #pageInput
        class="lum-paging__jump-to-page-input"
        type="number"
        [value]="rowData?.meta?.current_page || 0"
        (input)="handleGoToPageInput(pageInput)"
        (keyup.enter)="gotoPage(pageInput.value)"
        lumInvalidNumberInput
        lumFocusHighlight
      />
      <label class="lum-label my-2">of {{ rowData?.meta?.last_page }}</label>
    </div>
    <mat-paginator
      [length]="rowData?.meta?.total || 0"
      [pageSize]="rowData?.meta?.per_page || 0"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      aria-label="Select page"
      (page)="onPaginationChanged($event)"
    >
    </mat-paginator>
  </div>
</div>
